 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Cart~Checkout~Home~Login~Menu~Payment~Register~Reservations":"Cart~Checkout~Home~Login~Menu~Payment~Register~Reservations","Cart":"Cart","Checkout":"Checkout","CommandAdd~FastSale~Menu~SaleIndex~SalesReceivables":"CommandAdd~FastSale~Menu~SaleIndex~SalesReceivables","Menu":"Menu","Home":"Home","Login":"Login","Payment":"Payment","Register":"Register","Reservations":"Reservations","Categories":"Categories","CommandAdd":"CommandAdd","SalesReceivables":"SalesReceivables","CommandIndex~DocumentCreate~DocumentIndex~FastSale~SaleIndex~payments":"CommandIndex~DocumentCreate~DocumentIndex~FastSale~SaleIndex~payments","DocumentCreate~FastSale~People~SaleIndex~payments":"DocumentCreate~FastSale~People~SaleIndex~payments","FastSale":"FastSale","OrdersCreate":"OrdersCreate","SaleIndex":"SaleIndex","CommandIndex":"CommandIndex","DocumentCreate":"DocumentCreate","payments":"payments","DocumentIndex":"DocumentIndex","CommandZones":"CommandZones","CommandsReports~DocumentsReports~Inventories~InventoryHistories":"CommandsReports~DocumentsReports~Inventories~InventoryHistories","CommandsReports":"CommandsReports","DocumentsReports":"DocumentsReports","Inventories":"Inventories","InventoryHistories":"InventoryHistories","Configurations":"Configurations","Correlatives":"Correlatives","CulqiTokens":"CulqiTokens","DistributionAreas":"DistributionAreas","People":"People","Establishments":"Establishments","Faq":"Faq","FinalReceipt":"FinalReceipt","Ingredients":"Ingredients","Items":"Items","Locals":"Locals","Movements":"Movements","Orders":"Orders","Permissions":"Permissions","PrivacyPolicy":"PrivacyPolicy","Promotions":"Promotions","Recipes":"Recipes","Reports":"Reports","Roles":"Roles","Salons":"Salons","SearchInvoice":"SearchInvoice","Summaries":"Summaries","Tables":"Tables","TermsAndCondition":"TermsAndCondition","UnitTypes":"UnitTypes","Users":"Users","Verify":"Verify","Voided":"Voided","Waiters":"Waiters","cashes":"cashes","deliveryPayment":"deliveryPayment","histories":"histories","openings":"openings","tasks":"tasks"}[chunkId]||chunkId) + "." + {"Cart~Checkout~Home~Login~Menu~Payment~Register~Reservations":"50e112fc","Cart":"c0732de7","Checkout":"eda6fb42","CommandAdd~FastSale~Menu~SaleIndex~SalesReceivables":"7683f614","Menu":"40544583","Home":"6edd986d","Login":"d3953a01","Payment":"11d2b37d","Register":"925a6fcc","Reservations":"48001ea1","Categories":"bb64f714","CommandAdd":"36a3816e","SalesReceivables":"a3cfc6cb","CommandIndex~DocumentCreate~DocumentIndex~FastSale~SaleIndex~payments":"93af87a5","DocumentCreate~FastSale~People~SaleIndex~payments":"adc148cf","FastSale":"30b66299","OrdersCreate":"1b43bf23","SaleIndex":"2d74f60c","CommandIndex":"802d09ad","DocumentCreate":"e84abe56","payments":"eacebb60","DocumentIndex":"ec99a71b","CommandZones":"bf14ec49","CommandsReports~DocumentsReports~Inventories~InventoryHistories":"a75a19cb","CommandsReports":"7def3a2e","DocumentsReports":"89af88d8","Inventories":"77f9e417","InventoryHistories":"27897602","Configurations":"690804ff","Correlatives":"9c571ca2","CulqiTokens":"23596adb","DistributionAreas":"36ace2b1","People":"4a81c6bf","Establishments":"1cdde302","Faq":"03733480","FinalReceipt":"e85dbe8e","Ingredients":"7cde0fae","Items":"d5a26387","Locals":"a1720aa6","Movements":"4f6c55c7","Orders":"1e9f3639","Permissions":"daf6aee8","PrivacyPolicy":"daf6b374","Promotions":"5cb42d18","Recipes":"b01e34a3","Reports":"79f1d2a9","Roles":"1d460edf","Salons":"0be6bb93","SearchInvoice":"08c0811e","Summaries":"48e886f3","Tables":"c31136e6","TermsAndCondition":"171ccc79","UnitTypes":"27720df5","Users":"f0dc6fd9","Verify":"e0521e87","Voided":"b075d640","Waiters":"8e4579ac","cashes":"fb49f60b","chunk-2d0e5e97":"242906ab","deliveryPayment":"a3e8db61","histories":"fd4f2235","openings":"f7c47b7a","tasks":"7d40565c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Cart~Checkout~Home~Login~Menu~Payment~Register~Reservations":1,"Checkout":1,"CommandAdd~FastSale~Menu~SaleIndex~SalesReceivables":1,"Login":1,"Payment":1,"Register":1,"Categories":1,"SalesReceivables":1,"SaleIndex":1,"CommandIndex":1,"DocumentIndex":1,"CommandZones":1,"Configurations":1,"Correlatives":1,"People":1,"Establishments":1,"Faq":1,"Ingredients":1,"Orders":1,"Permissions":1,"Roles":1,"Salons":1,"Tables":1,"UnitTypes":1,"Users":1,"Voided":1,"Waiters":1,"cashes":1,"tasks":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Cart~Checkout~Home~Login~Menu~Payment~Register~Reservations":"Cart~Checkout~Home~Login~Menu~Payment~Register~Reservations","Cart":"Cart","Checkout":"Checkout","CommandAdd~FastSale~Menu~SaleIndex~SalesReceivables":"CommandAdd~FastSale~Menu~SaleIndex~SalesReceivables","Menu":"Menu","Home":"Home","Login":"Login","Payment":"Payment","Register":"Register","Reservations":"Reservations","Categories":"Categories","CommandAdd":"CommandAdd","SalesReceivables":"SalesReceivables","CommandIndex~DocumentCreate~DocumentIndex~FastSale~SaleIndex~payments":"CommandIndex~DocumentCreate~DocumentIndex~FastSale~SaleIndex~payments","DocumentCreate~FastSale~People~SaleIndex~payments":"DocumentCreate~FastSale~People~SaleIndex~payments","FastSale":"FastSale","OrdersCreate":"OrdersCreate","SaleIndex":"SaleIndex","CommandIndex":"CommandIndex","DocumentCreate":"DocumentCreate","payments":"payments","DocumentIndex":"DocumentIndex","CommandZones":"CommandZones","CommandsReports~DocumentsReports~Inventories~InventoryHistories":"CommandsReports~DocumentsReports~Inventories~InventoryHistories","CommandsReports":"CommandsReports","DocumentsReports":"DocumentsReports","Inventories":"Inventories","InventoryHistories":"InventoryHistories","Configurations":"Configurations","Correlatives":"Correlatives","CulqiTokens":"CulqiTokens","DistributionAreas":"DistributionAreas","People":"People","Establishments":"Establishments","Faq":"Faq","FinalReceipt":"FinalReceipt","Ingredients":"Ingredients","Items":"Items","Locals":"Locals","Movements":"Movements","Orders":"Orders","Permissions":"Permissions","PrivacyPolicy":"PrivacyPolicy","Promotions":"Promotions","Recipes":"Recipes","Reports":"Reports","Roles":"Roles","Salons":"Salons","SearchInvoice":"SearchInvoice","Summaries":"Summaries","Tables":"Tables","TermsAndCondition":"TermsAndCondition","UnitTypes":"UnitTypes","Users":"Users","Verify":"Verify","Voided":"Voided","Waiters":"Waiters","cashes":"cashes","deliveryPayment":"deliveryPayment","histories":"histories","openings":"openings","tasks":"tasks"}[chunkId]||chunkId) + "." + {"Cart~Checkout~Home~Login~Menu~Payment~Register~Reservations":"c6a285b6","Cart":"31d6cfe0","Checkout":"f921b4fd","CommandAdd~FastSale~Menu~SaleIndex~SalesReceivables":"7df717b5","Menu":"31d6cfe0","Home":"31d6cfe0","Login":"f921b4fd","Payment":"48f92153","Register":"d821258a","Reservations":"31d6cfe0","Categories":"3ab7a86c","CommandAdd":"31d6cfe0","SalesReceivables":"0814a253","CommandIndex~DocumentCreate~DocumentIndex~FastSale~SaleIndex~payments":"31d6cfe0","DocumentCreate~FastSale~People~SaleIndex~payments":"31d6cfe0","FastSale":"31d6cfe0","OrdersCreate":"31d6cfe0","SaleIndex":"0814a253","CommandIndex":"0814a253","DocumentCreate":"31d6cfe0","payments":"31d6cfe0","DocumentIndex":"98cebd45","CommandZones":"3ab7a86c","CommandsReports~DocumentsReports~Inventories~InventoryHistories":"31d6cfe0","CommandsReports":"31d6cfe0","DocumentsReports":"31d6cfe0","Inventories":"31d6cfe0","InventoryHistories":"31d6cfe0","Configurations":"3ab7a86c","Correlatives":"3ab7a86c","CulqiTokens":"31d6cfe0","DistributionAreas":"31d6cfe0","People":"3ab7a86c","Establishments":"3ab7a86c","Faq":"fca02344","FinalReceipt":"31d6cfe0","Ingredients":"3ab7a86c","Items":"31d6cfe0","Locals":"31d6cfe0","Movements":"31d6cfe0","Orders":"0814a253","Permissions":"3ab7a86c","PrivacyPolicy":"31d6cfe0","Promotions":"31d6cfe0","Recipes":"31d6cfe0","Reports":"31d6cfe0","Roles":"3ab7a86c","Salons":"3ab7a86c","SearchInvoice":"31d6cfe0","Summaries":"31d6cfe0","Tables":"3ab7a86c","TermsAndCondition":"31d6cfe0","UnitTypes":"3ab7a86c","Users":"0814a253","Verify":"31d6cfe0","Voided":"98cebd45","Waiters":"3ab7a86c","cashes":"3ab7a86c","chunk-2d0e5e97":"31d6cfe0","deliveryPayment":"31d6cfe0","histories":"31d6cfe0","openings":"31d6cfe0","tasks":"3ab7a86c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
